var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting" }, [
    _c("div", {
      staticClass: "el-icon-arrow-left more-icon-3 cursor hide",
      attrs: { id: "back-to-main" },
      on: { click: _vm.backToChart }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "history-title" }, [_vm._v("群管理")]),
    _vm._v(" "),
    _c("div", { staticClass: "pd-15 setting-main" }, [
      _c("div", { staticClass: "group-form" }, [
        _c("div", [
          _c("div", { staticClass: "margin-tb-7 color-86909c" }, [
            _vm._v("房间号：")
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "span",
              { staticClass: "color-4E5969", attrs: { id: "roomId" } },
              [_vm._v(_vm._s(_vm.clickItem.id))]
            ),
            _vm._v(" "),
            _c(
              "svg",
              {
                staticClass: "icon svg-icon float-r cursor",
                attrs: {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 1024 1024",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "p-id": "1850"
                },
                on: {
                  click: function($event) {
                    return _vm.copyRoomId(_vm.clickItem.id)
                  }
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M149.3504 394.6496c16.0256 0 29.3376 11.8784 31.6416 27.2896l0.3584 4.7104-0.0512 480h416.0512c16.0256 0 29.3376 11.8784 31.6416 27.2896l0.3584 4.7104a32 32 0 0 1-27.2896 31.6928l-4.7104 0.3072h-448a32 32 0 0 1-31.6928-27.2384l-0.3072-4.7616v-512c0-17.664 14.336-32 32-32zM640 53.3504a32.6656 32.6656 0 0 1 18.7392 6.0416 25.6 25.6 0 0 1 1.024 0.768l0.6144 0.512a32.2048 32.2048 0 0 1 2.3552 2.1504l0.8704 0.8704 234.6496 256 1.024 1.2288c0.6656 0.768 1.28 1.536 1.8432 2.4064l-2.8672-3.584a32.1536 32.1536 0 0 1 8.0896 16.896l-1.024-4.4032 0.768 2.9184 0.256 1.4336 0.0512 0.6144a32.1536 32.1536 0 0 1 0.2048 2.4576l0.0512 1.6896v469.2992c0 17.7152-14.336 32-32 32H277.3504a32 32 0 0 1-32-32V85.3504c0-17.664 14.336-32 32-32z m-32.0512 63.9488H309.2992v661.3504h533.3504V373.2992H640a32 32 0 0 1-31.6416-27.2384l-0.3584-4.7104-0.0512-224.0512z m53.4016 448a32 32 0 0 1 4.7104 63.6928l-4.7104 0.3584h-256a32 32 0 0 1-4.7616-63.6928l4.7616-0.3072h256zM490.6496 394.7008a32 32 0 0 1 4.7616 63.6928l-4.7616 0.3072H405.3504a32 32 0 0 1-4.7616-63.6416l4.7616-0.3584h85.2992z m181.3504-227.072l-0.0512 141.7216h129.9456l-129.8944-141.7216z",
                    "p-id": "1851"
                  }
                })
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "margin-tb-7 color-86909c" }, [
            _vm._v("房间名：")
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "span",
              { staticClass: "color-4E5969", attrs: { id: "roomName" } },
              [_vm._v(_vm._s(_vm.clickItem.name))]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { padding: "15px 0px" } },
        [
          _c("el-input", {
            staticClass: "form-control inline-block",
            attrs: {
              "prefix-icon": "el-icon-search",
              id: "filter-group-users",
              size: "small",
              placeholder: "搜索"
            },
            on: { input: _vm.filterGroupUserChange },
            model: {
              value: _vm.filterText,
              callback: function($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          {
            staticClass: "add-people cursor border-box",
            on: { click: _vm.openPeopleListModal }
          },
          [
            _c("span", {
              staticClass: "mt-10 iconfont icon-tianjiaqunchengyuan"
            }),
            _vm._v("添加成员")
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: { id: "group-users" }
        },
        _vm._l(_vm.groupPeopleShowData, function(item, index) {
          return _c("div", { key: index }, [
            _vm.groupCreateUserId === item.id
              ? _c("div", { staticClass: "group-people flex" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "" +
                        (item.avatarImageUrl
                          ? item.avatarImageUrl
                          : require("../../../static/avatar.jpg"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "group-text" }, [
                    _c("span", { staticClass: "ellipse ml-10" }, [
                      _vm._v(_vm._s(item.userName))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "roomCreator" }, [
                      _vm._v("群主")
                    ]),
                    _vm._v(" "),
                    item.id === _vm.myUserId
                      ? _c("span", { staticClass: "room-people-myself" }, [
                          _vm._v("本人")
                        ])
                      : _vm._e()
                  ])
                ])
              : _c("div", { staticClass: "group-people flex" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "" +
                        (item.avatarImageUrl
                          ? item.avatarImageUrl
                          : require("../../../static/avatar.jpg"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "group-text" }, [
                    _c("span", { staticClass: "ellipse ml-10" }, [
                      _vm._v(_vm._s(item.userName))
                    ]),
                    _vm._v(" "),
                    _vm.groupCreateUserId === _vm.myUserId
                      ? _c("span", {
                          staticClass:
                            "iconfont icon-qingliqunchengyuan cursor",
                          attrs: { title: "移除" },
                          on: {
                            click: function($event) {
                              return _vm.moveOutUser(item.id)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    item.id === _vm.myUserId
                      ? _c("span", { staticClass: "room-people-myself" }, [
                          _vm._v("本人")
                        ])
                      : _vm._e()
                  ])
                ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "setting-bottom" }, [
        _vm.groupCreateUserId === _vm.myUserId
          ? _c(
              "div",
              {
                staticClass: "out-group cursor delete-group border-r",
                on: { click: _vm.deleteGroup }
              },
              [_vm._v("解散群")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "out-group  cursor", on: { click: _vm.outOfGroup } },
          [_vm._v("退出群")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b673f9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b673f9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/chat/src/setting.vue
// module id = null
// module chunks = 